import { jarallax, jarallaxVideo } from "../../node_modules/jarallax/dist/jarallax.esm.js";

jarallaxVideo();

export default {
    init: function () {
        document.querySelectorAll(".jarallax").forEach((node) => {
            let options = JSON.parse(node.dataset.jarallaxOptions || "");

            if (options.disableMobile) {
                options.disableMobile = /iPad|iPhone|iPod|Android/;
            }

            jarallax(node, options);
        });

        jarallax(document.querySelectorAll(".jarallax"), {
            onDestroy: function () {

            }
        });
    },
    cleanup: function () {
        jarallax(document.querySelectorAll(".jarallax"), "destroy");
    }
};
